import React from 'react';
import {IndexRoute, Route} from 'react-router';
import {
    App,
    Home,
    About,
    HowItWorks,
    Toolkit,
    Media,
    FundRedirect,
    FundGenderScore,
    List,
    Compare,
    Family,
    Legal,
    WhyGenderEqualityFunds,
    Partners,
    IndexFunds,
    TargetDateSeries,
    NotFound,
  } from 'containers'

export default (store) => {
  return (
    <Route path="/" component={App}>
      { /* Home (main) route */ }
      <IndexRoute component={Home}/>

      { /* Routes */ }
      <Route path="/funds/:fundId/:investmentVehicleId/:ticker" component={FundRedirect}/>
      <Route path="/funds/:fundId/:investmentVehicleId" component={FundRedirect}/>
      <Route path="/fund/:name/:ticker/gender-lens-score/:fundId/:investmentVehicleId" component={FundGenderScore}/>
      <Route path="/funds" component={List}/>
      <Route path="/compare" component={Compare}/>
      <Route path="/families" component={Family}/>
      <Route path="/about" component={About}/>
      <Route path="/how-it-works" component={HowItWorks}/>
      <Route path="/action-toolkit" component={Toolkit}/>
      <Route path="/media" component={Media}/>
      <Route path="/legal" component={Legal}/>
      <Route path="/gender-equality-workplace" component={WhyGenderEqualityFunds}/>
      <Route path="/partners" component={Partners}/>
      <Route path="/index-funds" component={IndexFunds}/>
      <Route path="/target-date-funds" component={TargetDateSeries}/>
      <Route path="/target-date-funds/:strategyName" component={TargetDateSeries}/>
      
      { /* Catch all route */ }
      <Route path="*" component={NotFound} status={404} />
    </Route>
  );
};
